var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2033 0.5H2.77765C1.23662 0.5 0 1.66316 0 3.11263V14.8874C0 16.3189 1.23662 17.5 2.77765 17.5H13.2224C14.7444 17.5 16 16.3368 16 14.8874V3.11263C15.981 1.66316 14.7444 0.5 13.2033 0.5ZM14.4019 14.8874C14.4019 15.5137 13.8692 16.0147 13.2033 16.0147H2.77765C2.11177 16.0147 1.57907 15.5137 1.57907 14.8874V3.11263C1.57907 2.48632 2.11177 1.98526 2.77765 1.98526H13.2224C13.8882 1.98526 14.4209 2.48632 14.4209 3.11263V14.8874H14.4019Z",
    fill: "#172B4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79429 4.68735H4.54697C4.1094 4.68735 3.74792 5.02735 3.74792 5.43893C3.74792 5.85051 4.1094 6.19051 4.54697 6.19051H4.79429C5.23187 6.19051 5.59334 5.85051 5.59334 5.43893C5.59334 5.02735 5.23187 4.68735 4.79429 4.68735Z",
    fill: "#172B4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79429 8.24839H4.54697C4.1094 8.24839 3.74792 8.58839 3.74792 8.99997C3.74792 9.41154 4.1094 9.75154 4.54697 9.75154H4.79429C5.23187 9.75154 5.59334 9.41154 5.59334 8.99997C5.59334 8.58839 5.23187 8.24839 4.79429 8.24839Z",
    fill: "#172B4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79429 11.8095H4.54697C4.1094 11.8095 3.74792 12.1495 3.74792 12.5611C3.74792 12.9727 4.1094 13.3127 4.54697 13.3127H4.79429C5.23187 13.3127 5.59334 12.9727 5.59334 12.5611C5.59334 12.1495 5.23187 11.8095 4.79429 11.8095Z",
    fill: "#172B4D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.453 4.68735H7.45779C7.02021 4.68735 6.65874 5.02735 6.65874 5.43893C6.65874 5.85051 7.02021 6.19051 7.45779 6.19051H11.453C11.8906 6.19051 12.2521 5.85051 12.2521 5.43893C12.2521 5.02735 11.8906 4.68735 11.453 4.68735Z",
    fill: "#172B4D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.453 8.24839H7.45779C7.02021 8.24839 6.65874 8.58839 6.65874 8.99997C6.65874 9.41154 7.02021 9.75154 7.45779 9.75154H11.453C11.8906 9.75154 12.2521 9.41154 12.2521 8.99997C12.2521 8.58839 11.8906 8.24839 11.453 8.24839Z",
    fill: "#172B4D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.453 11.8095H7.45779C7.02021 11.8095 6.65874 12.1495 6.65874 12.5611C6.65874 12.9727 7.02021 13.3127 7.45779 13.3127H11.453C11.8906 13.3127 12.2521 12.9727 12.2521 12.5611C12.2521 12.1495 11.8906 11.8095 11.453 11.8095Z",
    fill: "#172B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecks);
export default __webpack_public_path__ + "static/media/checks.2a231d07655d138e8960913e41776077.svg";
export { ForwardRef as ReactComponent };